/* eslint-disable */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import type { FC } from 'react';
import {Alert, Box, CircularProgress, Collapse, Container, Grid, Typography} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);
import { useStyles } from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import WidgetTile from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetTile';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import aplicacionEfectivoIcon from 'src/assets/icons/totalAplicacionEfectivo.svg'
import flujoNetoEfectivoIcon from 'src/assets/icons/totalFlujoNetoEfectivo.svg'
import superavitEfectivoIcon from 'src/assets/icons/superavitIcon.svg'
import fuentesEfectivoIcon from 'src/assets/icons/totalFuentesEfectivo.svg'
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import WidgetBalance from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetBalance';
import TablaFinanciera from 'src/components/dashboard/overview/masterOverview/Tablas/TablaFinanciera';
import WidgeTwoColumns from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgeTwoColumns';
import ChartUtilidadNeta from 'src/components/dashboard/overview/masterOverview/Charts/ChartUtilidadNeta';
import ChartDeficit from 'src/components/dashboard/overview/masterOverview/Charts/ChartDeficit';
import TablaFinSmall from "../../components/dashboard/overview/masterOverview/Tablas/TablaFinSmall";
import {addDays, addMonths} from "date-fns";
import {getZazacorpPrediction} from "../../components/bridges/BridgeBusiness";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import TablaPresupuesto from "../../components/dashboard/overview/masterOverview/Tablas/TablaPresupuesto";
import TablaPresSmall from "../../components/dashboard/overview/masterOverview/Tablas/TablaPresSmall";

const OverviewPresupuestoEfectivo: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const [valueSuperavit, setValueSuperAvit] = useState([]);
  const [otherData, setOtherData] = useState({});
  const { t } = useTranslation('dashboard');
  const date = new Date();
  let nextDate = new Date(date)
  nextDate.setFullYear(date.getFullYear() +1)
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [tablaData, setTablaData] = useState({header: ["No hay datos para la fecha seleccionada"], rows: []});
  const [smallTableData, setSmallTablaData] = useState({header: ["No hay datos para la fecha seleccionada"], rows: []});
  const [goingUp, setGoingUp] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [superavit, setSuperavit] = useState(0);
  const [flujoEfectivo, setFlujoEfectivo] = useState(0);
  const [aplicacionesEfectivo, setAplicacionesEfectivo] = useState(0);
  const [fuentesEfectivo, setFuentesEfectivo] = useState(0);
  const [valueFromDate, setValueFromDate] = useState(new Date());
  const [valueFromDateFormatted, setValueFromDateFormatted] = useState(valueFromDate.toLocaleDateString('es-EC', {
    day: '2-digit',   // Día en dos dígitos
    month: '2-digit', // Mes en dos dígitos
    year: '2-digit'   // Año en dos dígitos
  }));
  const [valueToDate, setValueToDate] = useState(addDays(valueFromDate, 6));
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );

  const [valueDate, setvalueDate] = useState(new Date());
  const [openTable, setOpenTable] = useState(false);



  const year = valueFromDate.getFullYear();
      const month = String(valueFromDate.getMonth() + 1).padStart(2, '0');
      const day = String(valueFromDate.getDate()).padStart(2, '0');
      let formattedFromDate = `${year}-${month}-${day}`;
      console.log("formattedFromDate", formattedFromDate)

      

      // const formattedFromDate = valueFromDate.toISOString().split('T')[0];
      const toDate = addDays(valueFromDate,6);
      const yearToDate = toDate.getFullYear();
      const monthToDate = String(toDate.getMonth() + 1).padStart(2, '0');
      const dayToDate = String(toDate.getDate()).padStart(2, '0');
      let formattedToDate = `${yearToDate}-${monthToDate}-${dayToDate}`;
      console.log("formattedToDate", formattedToDate)


      const todayDate = new Date()
      const yearTodayDate = todayDate.getFullYear();
      const monthTodayDate = String(todayDate.getMonth() + 1).padStart(2, '0');
      const dayTodayDate = String(todayDate.getDate()).padStart(2, '0');
      let formattedTodayDate = `${yearTodayDate}-${monthTodayDate}-${dayTodayDate}`;
      console.log("formattedTodayDate", formattedTodayDate)


      let flag = formattedFromDate === formattedTodayDate

  const reorderRows = (order,rows) => {
    

    // Create a new array to hold the reordered rows
    const reorderedRows = [];

    // Iterate through the order array and match it to the row data
    order.forEach((title) => {
      const matchingRow = rows.find((row) => row.data[0] === title);
      console.log("title", title)
      console.log("matchingRow", matchingRow)
      if (matchingRow) {
        reorderedRows.push(matchingRow);
      }
    });


    console.log("reorderedRowsFunc", reorderedRows)

    return reorderedRows;
  };

  const buildAgregattedTable = async (today, week, month, nextMonth) => {

    console.log("monthAggregatedTable", month)

    type Row = {
      data: any[];
      subRows?: Row[];
    };
    type DataStruct = {
      header: string[];
      rows: Row[];
    };


    const dataHoy: DataStruct = today;
    const dataSemanal: DataStruct = week;
    const dataMensualAgregada: DataStruct = month;
    const dataProximoMes: DataStruct = nextMonth;

    function mergeData(dayData: DataStruct, monthData: DataStruct, nextMonthData: DataStruct, weeklyData: DataStruct): DataStruct {
      console.log("n")
      console.log("dayData", dayData)
      console.log("weeklyData", weeklyData)
      const mergedRows = weeklyData.rows.map((weeklyRow) => {
        console.log("weelkgROw", weeklyRow)
        const dayRow = dayData.rows.find(row => row.data[0] === weeklyRow.data[0]);
        const monthRow = monthData.rows.find(row => row.data[0] === weeklyRow.data[0]);
        const nextMonthRow = nextMonthData.rows.find(row => row.data[0] === weeklyRow.data[0]);
        if(weeklyRow.data[0] === "Saldo minimo de efectivo"){
          console.log("dayrow", dayRow)
          console.log("monthRow", monthRow)
          console.log("NextMonthData", nextMonthData)
          console.log("nextMonthRow", nextMonthRow)
        }

        return {
          ...weeklyRow,
          data: [
            weeklyRow.data[0], // Nombre de la fila
            dayRow ? dayRow.data[1] : 0, // Valor de "Hoy"
            monthRow ? monthRow.data[1] : 0, // Valor de "Mes"
            nextMonthRow ? nextMonthRow.data[1] : 0, // Valor de "Próximo Mes"
            ...weeklyRow.data.slice(1)
          ],
          subRows: mergeSubRows(dayRow?.subRows, monthRow?.subRows, nextMonthRow?.subRows, weeklyRow.subRows)
        };
      });


      console.log("mergedRows", mergedRows)
      const formatDate = (date) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
      };
      const getMonth = (date) => {
        const options = { month: 'long' };
        const month = date.toLocaleString('es-ES', options);
        return month.charAt(0).toUpperCase() + month.slice(1);
      };
      const formattedDate = formatDate(valueDate);
      const currentMonth = getMonth(date);
      const nextMonth = getMonth(addMonths(date,1));

      

      return {
        header: flag ? ["Hoy", `Total Restante ${currentMonth}`, nextMonth, formatDate(addDays(valueDate, 1)), ...weeklyData.header.slice(1)] : ["Hoy", `Total Restante ${currentMonth}`, nextMonth, formattedDate, ...weeklyData.header.slice(0,-1)],
        rows: mergedRows
      };
    }

    function mergeSubRows(daySubRows: Row[] = [], monthSubRows: Row[] = [], nextMonthSubRows: Row[] = [], weeklySubRows: Row[] = []): Row[] {
      return weeklySubRows.map((weeklySubRow) => {
        const daySubRow = daySubRows.find(subRow => subRow.data[0] === weeklySubRow.data[0]);
        const monthSubRow = monthSubRows.find(subRow => subRow.data[0] === weeklySubRow.data[0]);
        const nextMonthSubRow = nextMonthSubRows.find(subRow => subRow.data[0] === weeklySubRow.data[0]);

        return {
          ...weeklySubRow,
          data: [
            weeklySubRow.data[0], // Nombre de la fila
            daySubRow ? daySubRow.data[1] : 0, // Valor de "Hoy"
            monthSubRow ? monthSubRow.data[1] : 0, // Valor de "Mes"
            nextMonthSubRow ? nextMonthSubRow.data[1] : 0, // Valor de "Próximo Mes"
            ...weeklySubRow.data.slice(1)
          ],
          subRows: mergeSubRows(daySubRow?.subRows, monthSubRow?.subRows, nextMonthSubRow?.subRows, weeklySubRow.subRows)
        };
      });
    }


    const mergedData = mergeData(dataHoy, dataMensualAgregada, dataProximoMes, dataSemanal);
    return mergedData;
  };

  const buildPeTableJson = async (data) => {
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });


    console.log("headerDates", headerDates)

    // Transformar las claves de fecha en fechas formateadas
    const fechaBase = new Date(valueFromDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      //console.log("currentDate", currentDate)
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });

    console.log("formattedDates", formattedDates)


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
      const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

      const indexParts = item.index.split('.');
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (indexParts.length === 1) {
        // Es una categoría principal
        rows.push(row);
      } else {
        // Es una subcategoría
        const parentIndex = indexParts.slice(0, -1).join('.');
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    return {header: formattedDates, rows};
  };


  const buildPeTableJson2 = async (data) => {
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });


    console.log("headerDates", headerDates)

    // Transformar las claves de fecha en fechas formateadas
    const fechaBase = new Date(valueFromDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      //console.log("currentDate", currentDate)
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });

    console.log("formattedDates", formattedDates)


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
      const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

      const indexParts = item.index.split('.');
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (indexParts.length === 1) {
        // Es una categoría principal
        rows.push(row);
      } else {
        // Es una subcategoría
        const parentIndex = indexParts.slice(0, -1).join('.');
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    return {header: formattedDates, rows};
  };

  const buildMonthTableJson = (data) => {
    console.log("dataBuildMonthTableJson", data)
    // Create a map to maintain references to the rows based on their indexes
    const indexToRowMap = new Map();

    // Create the structure of rows and subrows
    const rows = [];

    data.forEach(item => {
      const rowData = [item.name, item.total];
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (!item.parentcode) {
        // It's a main category
        rows.push(row);
      } else {
        // It's a subcategory
        const parentIndex = data.find(parentItem => parentItem.acctcode === item.parentcode)?.index;
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    return { header: ["Nombre de la fila", "Total"], rows };
  };

  const buildGraph = async (data) => {
    const fechaBase = new Date(valueFromDate);
    const length = data.header.length;
    let datesArray = [];
    let tempData = [];
    let tempOtherData = {
      salidas: [],
      entradas: []
    };
    for (let i = 0; i < length; i++) {
      let futureDate = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate() + i);
      datesArray.push(futureDate.getTime()); // No division by 1000, to get milliseconds
    }
    await Promise.all(data.rows.map(async (row) => {
      if (row.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos") {
        const [, ...restOfData] = row.data;
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempData.push(tempDateData);
        })
      } else if (row.data[0] === "Total salidas de efectivo") {
        const [, ...restOfData] = row.data;
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempOtherData.salidas.push(tempDateData);
        })
      } else if (row.data[0] === "Total entradas de efectivo") {
        const [, ...restOfData] = row.data;
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempOtherData.entradas.push(tempDateData);
        })
      }
    }));
    let formatData = [];
    let formatOtherData = {
      salidas: [],
      entradas: []
    };
    tempData.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatData.push(newVal);
    });
    tempOtherData.salidas.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatOtherData.salidas.push(newVal);
    });
    tempOtherData.entradas.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatOtherData.entradas.push(newVal);
    });
    setOtherData(formatOtherData);

    if(Object.keys(valueSuperavit).length === 0){
      setValueSuperAvit(formatData);
    }
  }


  

  async function getPredictions() {
    const now = new Date();
    const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);


    const yearEndDate = endOfCurrentMonth.getFullYear();
    const monthEndDate = String(endOfCurrentMonth.getMonth() + 1).padStart(2, '0');
    const dayEndDate = String(endOfCurrentMonth.getDate()).padStart(2, '0');
    let formattedEndMonth = `${yearEndDate}-${monthEndDate}-${dayEndDate}`;


    const endOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);


    const yearEndNextDate = endOfNextMonth.getFullYear();
    const monthEndNextDate = String(endOfNextMonth.getMonth() + 1).padStart(2, '0');
    const dayEndNextDate = String(endOfNextMonth.getDate()).padStart(2, '0');
    let formattedEndNextMonth = `${yearEndNextDate}-${monthEndNextDate}-${dayEndNextDate}`;
    try {
      setIsLoading(true);

      
      

      

      if(formattedFromDate === formattedTodayDate){
        const newFromDate = addDays(valueFromDate,1)
        const year = newFromDate.getFullYear();
        const month = String(newFromDate.getMonth() + 1).padStart(2, '0');
        const day = String(newFromDate.getDate()).padStart(2, '0');
        formattedFromDate = `${year}-${month}-${day}`;
        
      }

      console.log("newFormattedFromDate", formattedFromDate)

      const todayDatePE = new Date()
      const yearToDatePE = todayDatePE.getFullYear();
      const monthToDatePE = String(todayDatePE.getMonth() + 1).padStart(2, '0');
      const dayToDatePE = String(todayDatePE.getDate()).padStart(2, '0');
      const formattedToDatePE = `${yearToDatePE}-${monthToDatePE}-${dayToDatePE}`;


      // console

      


      
      
      
      
      const todayInfo = await getZazacorpPrediction(formattedToDatePE,formattedToDatePE, 'pe_predict');
      const tableToday = await buildPeTableJson(todayInfo.resultRangeDates);

      const tableMonth = await buildMonthTableJson(todayInfo.resultUntilEndMonth);
      const nextMonthTableJson = buildMonthTableJson(todayInfo.resultOfNextMonth);
      const response = await getZazacorpPrediction(formattedFromDate,formattedToDate, 'pe_predict');
      const tableJson = await buildPeTableJson2(response.result7Days);

      const responseEndMonth = await getZazacorpPrediction(formattedEndMonth, formattedEndMonth, 'pe_predict');
      const tableJsonEndMonth = await buildPeTableJson(responseEndMonth.resultRangeDates);

      const deficitEndMonth = tableJsonEndMonth.rows.filter(r => r.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos")

      const responseEndMonthNext = await getZazacorpPrediction(formattedEndNextMonth, formattedEndNextMonth, 'pe_predict');
      const tableJsonEndMonthNext= await buildPeTableJson(responseEndMonthNext.resultRangeDates);

      const deficitEndMonthNext = tableJsonEndMonthNext.rows.filter(r => r.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos")

      let aggregatedTable = await buildAgregattedTable(tableToday, tableJson, tableMonth, nextMonthTableJson);


      console.log("aggregatedTable", aggregatedTable)


      aggregatedTable.rows[10].data[2] = deficitEndMonth[0].data[1]
      aggregatedTable.rows[10].data[3] = deficitEndMonthNext[0].data[1]



      

      const orderAgreggatedRows = ["Ventas Totales","Recaudacion total","Compras MP, MOD y CIF","Aplicaciones de efectivo por Gastos Operacionales","Gastos de Ventas","Gastos Administrativos","Gastos de Inversión y Financiamiento","Gastos No Operacionales","Gastos de Operacionales Descontinuadas",
        "Impuestos","Otros Gastos 1","Otros Gastos 2","Total de Efectivo en Periodo Anterior","Total entradas de efectivo","Total salidas de efectivo",
        "Flujo Neto de Efectivo","Exceso Acumulativo en Saldos de Efectivo","Saldo minimo de efectivo","Superavit-Deficit de requerimientos financieros Acumulativos"]
   

      const orderAgreggatedSubrows = {
        //"Ventas Totales": {},
        "Impuestos":["Impuesto IVA y Retenciones","Impuestos a la Renta"],
        //"Otros Gastos 1": {},
        "Otros Gastos 2": ["Participacion de Trabajadores","Dividendos a Socios" ],
        //"Total de Efectivo en Periodo Anterior": {},
        //"Total Entradas de Efectivo": {},
        //"Total Salidas de Efectivo": {},
        //"Flujo Neto de Efectivo": {},
        //"Exceso Acumulativo en Saldos de Efectivo": {},
        //"Saldo minimo de efectivo": {},
        //"Superavit-Deficit de Requerimientos Financieros Acumulativos": {},
        //"Recaudacion total": {},
        
        "Compras MP, MOD y CIF": ["Compras por Materiales Utilizados o Productos Vendidos","Compras por Mano de Obra Directa", "Compras por Mano de Obra Indirecta", "Compras por costos indirectos de fabricacion" ],
        "Aplicaciones de efectivo por Gastos Operacionales": ["Materiales Utilizados o Productos Vendidos","Mano de Obra Directa", "Mano de Obra Indirecta", "Costos Indirectos de Fabricacion"],
        "Gastos de Ventas": ["Sueldos, salarios y demas remuneraciones ventas", "Alimentacion ventas","Aporte Patronal I.E.S.S. ventas","Secap ventas", "I.E.C.E ventas", "Honorarios extranjeros por servicios ocasionales ventas", "Mantenimiento y reparaciones ventas","Comisiones ventas", "Bonficacion ventas",  "Combustible ventas", "Viajes ventas", "Energia Electrica ventas", "Telefono ventas","Decimo Cuarto Sueldo ventas", "Decimo Tercer Sueldo ventas", "Fondo De Reserva ventas", "Vacaciones ventas", "Suministros, materiales y repuestos ventas","Otros Gastos ventas" ],
        "Gastos Administrativos": ["Sueldos salarios y demas remuneraciones adm", "Alimentacion adm", "Aporte Patronal I.E.S.S. adm", "Secap adm", "I.E.C.E adm", "Fondo De Reserva adm", "Decimo Tercer Sueldo adm", "Decimo Cuarto Sueldo adm", "Vacaciones adm", "Honorarios profesionales adm", "Servicios profesionales adm", "Arriendos adm",  "Comisiones adm", "Combustible adm", "Viajes adm", 'Telefono adm', "Internet adm", "Uniformes adm", "Guardiania", "Otros gastos adm" ],
        "Gastos de Inversión y Financiamiento": ["Inversion en Activos Fijos", "Inversion en Activos Intangibles","Prestamos Bancarios", "Intereses Financieros", "Tarjetas de Credito", "Comisiones Financieras",  "Otros Gastos Financieros"],
        //"Gastos No Operacionales": {},
        //"Gastos de Operacionales Descontinuadas": {},

      }



      aggregatedTable = {header: aggregatedTable.header,rows: reorderRows(orderAgreggatedRows, aggregatedTable.rows)}


      console.log("aggregatedTableFinal0", aggregatedTable)
      
      aggregatedTable = {header: aggregatedTable.header,rows: aggregatedTable.rows.map(r => {
        if(r.data[0] in orderAgreggatedSubrows){
          r.subRows = reorderRows(orderAgreggatedSubrows[r.data[0]], r.subRows)
        }
        return r
      })}


      console.log("aggregatedTableFinal", aggregatedTable)

      



    

      const order = [
      "Total entradas de efectivo",
      "Compras MP, MOD y CIF",
      "Gastos de Ventas",
      "Gastos Administrativos",
      "Gastos de Inversión y Financiamiento",
      "Gastos No Operacionales",
      "Gastos de Impuestos",
      "Total salidas de efectivo",
      "Superavit-Deficit de requerimientos financieros Acumulativos",
    ];
      const newTable = {
        header: aggregatedTable.header,
        rows: reorderRows(order,aggregatedTable.rows),
      };
      

      console.log("aggregatedTable", aggregatedTable)

      // newTable.header.splice(3,1)



      // console.log(JSON.stringify(aggregatedTable, null, 2));
      const tempSuperAvit = aggregatedTable.rows.find(category => category.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos").data[1];
      const tempFlujoEfectivo = aggregatedTable.rows.find(category => category.data[0] === "Flujo Neto de Efectivo").data[1];
      const tempAplicacionesEfectivo = aggregatedTable.rows.find(category => category.data[0] === "Total salidas de efectivo").data[1];
      const tempFuentesEfectivo = aggregatedTable.rows.find(category => category.data[0] === "Total entradas de efectivo").data[1];
      const smallTableDate = { header: aggregatedTable.header, rows: []};
      aggregatedTable.rows.map(section => {
        if (section.data[0] === "Total entradas de efectivo"
            || section.data[0] === "Total salidas de efectivo") {
          smallTableDate.rows.push(section);
        }
      });
      aggregatedTable.rows.map(section => {
       if (section.data[0] === "Compras MP, MOD y CIF" || section.data[0] === "Gastos de Ventas" ||
            section.data[0] === "Gastos Administrativos" || section.data[0] === "Gastos de Inversión y Financiamiento"
            || section.data[0] === "Gastos No Operacionales" || section.data[0] === "Gastos de Impuestos") {
          smallTableDate.rows.push(section);
        }
      });
      // aggregatedTable.rows.map(section => {
      //   if (section.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos") {
      //     smallTableDate.rows.push(section);
      //   }
      // });
      setSmallTablaData(newTable);
      setTablaData(aggregatedTable);
      setSuperavit(tempSuperAvit);
      setFlujoEfectivo(tempFlujoEfectivo);
      setAplicacionesEfectivo(tempAplicacionesEfectivo);
      setFuentesEfectivo(tempFuentesEfectivo);
      const graphTableJson = await buildPeTableJson(response.resultUntilEndYear);
      buildGraph(graphTableJson);
      // setNotInfo(false);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      // setNotInfo(true);
    }
  }

  const handleOpenTable = (newValue) => {
    setOpenTable(newValue);
  };

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  useEffect(() => {
    getPredictions();
  }, [valueFromDate, valueToDate]);

  const onIdle = () => {
    window.location.reload();
  };

  const handleOnDateChange = (date: any) => {
    setvalueDate(date);
    setValueFromDate(date);
    let formattedDate = date.toLocaleDateString('es-EC', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
    setValueFromDateFormatted(formattedDate);
  }

  return (
    
    <div>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "background.default",
    }}
  >
    <Container maxWidth={false} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={12} md={12}>
            <Collapse in={displayAlert}>
              <Alert
                severity="warning"
                variant="outlined"
                sx={{ bgcolor: 'background.paper', color: '#034787' }}
                onClose={() => { setDisplayAlert(false); }}
              >
                Se proyecta para la fecha {now} una disminución en el superávit (déficit) de
                requerimientos financieros acumulativos por <span style={{ fontWeight: 'bold', fontSize: '1.05rem' }}> $3,815.43</span>.
              </Alert>
            </Collapse>
          </Grid>

          <Grid item xs={12} md={10} display="flex" alignItems="center" sx={{ paddingTop: '7px' }}>
            <MonetizationOnIcon sx={{ color: '#001930' }} fontSize="medium" />
            <Typography
              sx={{
                paddingLeft: 1,
                fontWeight: 700,
                fontSize: '1.825rem',
              }}
              color="textSecondary"
            >
              Presupuesto de Efectivo
            </Typography>
          </Grid>

          <Grid item xs={12} md={2} display="flex" alignItems="center">
            <Typography color="#42526E" fontWeight={500} mr={1} display="flex">Fecha</Typography>
            <DatePicker
              selected={valueDate}
              minDate={new Date()}
              maxDate={nextDate}
              locale="es"
              onChange={handleOnDateChange}
              dateFormat="yyyy-MM-dd"
              className={classes.datePicker}
              popperClassName={classes.datePickerPopper}
            />
          </Grid>

          {isLoading ? (
            <Grid item xs={12} md={12} pt={10} display="flex" justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : (
            <>
              {openTable === true ? (
                <Grid item xs={12}>
                  <div ref={bottomRef}>
                    <TablaPresupuesto data={tablaData} openTable={handleOpenTable} title="Aplicaciones de Efectivo" />
                  </div>
                </Grid>
              ) : (
                <>
                  <Grid container spacing={2} pt={2} pl={2}>
                    <Grid item xs={12} md={3}>
                      <WidgetTile
                        topSubtitle="Total Fuentes de Efectivo:"
                        icon={<img src={fuentesEfectivoIcon} height="36px" width="36px" alt="fuentesEfectivoIcon" />}
                        value={fuentesEfectivo}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <WidgetTile
                        topSubtitle="Total Aplicaciones de Efectivo:"
                        icon={<img src={aplicacionEfectivoIcon} height="36px" width="36px" alt="aplicacionEfectivoIcon" />}
                        value={aplicacionesEfectivo}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <WidgetTile
                        topSubtitle="Total Flujo Neto de Efectivo:"
                        icon={<img src={flujoNetoEfectivoIcon} height="36px" width="36px" alt="flujoNetoEfectivoIcon" />}
                        value={flujoEfectivo}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <WidgetTile
                        topSubtitle="Superávit (Déficit) de Req. Fin. Acum:"
                        icon={<img src={superavitEfectivoIcon} height="36px" width="36px" alt="superavitEfectivoIcon" />}
                        value={superavit}
                        backgroundBlue={false}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <ChartDeficit data={valueSuperavit} otherData={otherData} />
                  </Grid>

                  <Grid item xs={12}>
                    <div ref={bottomRef}>
                      {smallTableData.rows.length !== 0 && (
                        <TablaPresSmall data={smallTableData} openTable={handleOpenTable} title="Presupuesto de Efectivo" />
                      )}
                    </div>
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Box>

      <Box component="footer" sx={{ py: 2 }}>
        <Typography sx={{ fontSize: '1rem' }}>© 2025 Dynamics Within. Todos los Derechos Reservados.</Typography>
      </Box>
    </Container>
  </Box>
</div>
   
  );
};

export default OverviewPresupuestoEfectivo;

